export const environment = {
   production: false,
   api_url: 'https://api.masterloop.betabike.no/',
   app_name: 'Masterloop Betabike Cloud',
   api_version: '5',
   live_port: '10443',
   live_connection_secured: true
};
